// extracted by mini-css-extract-plugin
export default {"isActive":"route-tabs__isActive___ZaIn6","underline":"route-tabs__underline___qmHUI","sublink":"route-tabs__sublink___v7JZB","link":"route-tabs__link___jNWcP"};